import { b64decode, b64encode } from '../../common/base64.js';
import { FakeBlob } from '../FakeBlob.js';
import { readBlobSync } from '../readBlobSync.js';
import { string2ArrayBuffer } from '../string2ArrayBuffer.js';
export const blobTypeDef = {
    Blob: {
        test: (blob, toStringTag) => toStringTag === 'Blob' || blob instanceof FakeBlob,
        replace: (blob) => ({
            $t: 'Blob',
            v: blob instanceof FakeBlob
                ? b64encode(blob.buf)
                : b64encode(string2ArrayBuffer(readBlobSync(blob))),
            type: blob.type,
        }),
        revive: ({ type, v }) => {
            const ab = b64decode(v);
            const buf = ab.buffer.byteLength === ab.byteLength
                ? ab.buffer
                : ab.buffer.slice(ab.byteOffset, ab.byteOffset + ab.byteLength);
            return typeof Blob !== 'undefined'
                ? new Blob([new Uint8Array(buf)], { type })
                : new FakeBlob(buf, type);
        },
    },
};
export default blobTypeDef;
